import { Questions } from "./Questions";

export class QuestionModel {
    questionType: string;
    domainType:string;
    proposal:string;
    questionsList: Questions[];
}